import styled from 'styled-components';
import { rem } from 'polished';
var DateTime = styled.span.withConfig({
  displayName: "FormatDateTimestyles__DateTime",
  componentId: "sc-1kzjthb-0"
})([""]);
var Date = styled.span.withConfig({
  displayName: "FormatDateTimestyles__Date",
  componentId: "sc-1kzjthb-1"
})(["white-space:nowrap;"]);
var Time = styled.span.withConfig({
  displayName: "FormatDateTimestyles__Time",
  componentId: "sc-1kzjthb-2"
})(["white-space:nowrap;text-transform:uppercase;"]);
var Spacer = styled.span.withConfig({
  displayName: "FormatDateTimestyles__Spacer",
  componentId: "sc-1kzjthb-3"
})(["display:inline-block;width:", ";"], rem(4));
export var Styled = {
  DateTime: DateTime,
  Date: Date,
  Time: Time,
  Spacer: Spacer
};